import { render, staticRenderFns } from "./results-board.vue?vue&type=template&id=4c35fba4&scoped=true&"
import script from "./results-board.vue?vue&type=script&lang=ts&"
export * from "./results-board.vue?vue&type=script&lang=ts&"
import style0 from "./results-board.vue?vue&type=style&index=0&id=4c35fba4&lang=scss&scoped=true&"
import style1 from "./results-board.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c35fba4",
  null
  
)

export default component.exports